import { writable } from "svelte/store";

const createConfirmationStore = () => {
  const { subscribe, set } = writable({
    show: false,
    message: "",
    confirmText: "Confirm",
    cancelText: "Cancel",
    onConfirm: null,
    onCancel: null,
  });

  return {
    subscribe,
    show: (config) =>
      set({
        show: true,
        message: config.message,
        confirmText: config.confirmText ?? "Confirm",
        cancelText: config.cancelText ?? "Cancel",
        onConfirm: config.onConfirm,
        onCancel: config.onCancel ?? (() => {}),
      }),
    hide: () =>
      set({
        show: false,
        message: "",
        confirmText: "Confirm",
        cancelText: "Cancel",
        onConfirm: null,
        onCancel: null,
      }),
  };
};

export const confirmationStore = createConfirmationStore();
